import axios from "axios";
import {utilityServicesPath} from "../../Constants";
import FileService from "../orders/orders/organization/FileService";

export default class UtilityService {

    static async getFolders() {
        return axios.get(`${utilityServicesPath}/admin/files/folders`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getFiles() {
        return axios.get(`${utilityServicesPath}/admin/files`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteFiles(path) {
        return await axios.delete(`${utilityServicesPath}/admin/files?path=${path}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }

    static async userMailing(email) {
        return await axios.post(`${utilityServicesPath}/user/mailing?email=${email}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getBanners() {
        return axios.get(`${utilityServicesPath}/admin/banners`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getById(id) {
        return axios.get(`${utilityServicesPath}/user/banners/${id}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getCurrencies() {
        return axios.get(`${utilityServicesPath}/organizations/currencies`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllProjectFileNames(orderId) {
        return axios.get(`${utilityServicesPath}/organizations/file-names/orders/${orderId}/project`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getOrderCustomerInOrganization(orderId) {
        return axios.get(`${utilityServicesPath}/organizations/file-names/orders/${orderId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }


    static async editFile(fileId, data) {
        return await axios.put(`${utilityServicesPath}/organizations/file-names/${fileId}`, JSON.stringify(data), {
            headers: {
                "Content-Type": "application/json",
            }
        });
    }


    static async uploadOrderFile(year, orderId, fileNameType, files) {
        return await axios.post(`${utilityServicesPath}/organizations/files/upload/order-files?orderId=${orderId}&year=${year}&fileNameType=${fileNameType}`,
            FileService.getFormDataArray(files), {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
    }

    static async delete(fileId) {
        return await axios.delete(`${utilityServicesPath}/organizations/files/delete?fileId=${fileId}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }

    static async downloadFile(fileId) {
        return axios.get(`${utilityServicesPath}/organizations/files/${fileId}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }
}
